<template>
  <div id="pest-area" style="overflow:hidden;">
    <div class="pestArea-data">
      <div class="pestArea-data-head">
        <div class="pestArea-head-title">
          <span class="pestArea-head-title-Container">虫情区域统计</span>
        </div>

        <div class="pestArea-head-select">
          <div class="pestArea-head-device">
            <el-select @change="pestDeviceChange($event)" v-model="defaultPestArea" filterable>
              <el-option :key="item.groupId" :label="item.groupName" :value="item.groupId" v-for="item in pestAreaList"></el-option>
            </el-select>
          </div>

          <div class="pestArea-head-time">
            <el-date-picker @change="areaSelectTime" v-model="defaultAreaTime" unlink-panels type="datetimerange" :picker-options="areaPickerOption" align="right"
                            end-placeholder="结束日期" key="time" range-separator="至" start-placeholder="开始日期">
            </el-date-picker>
          </div>

          <div class="pestArea-head-btn">
            <el-button type="primary" @click="areaQueryData()">查询</el-button>
            <el-button type="warning" @click="areaExportData()">导出</el-button>
          </div>
        </div>
      </div>

      <div class="pestArea-data-content" style="overflow: auto;">
        <div id="worn" class="pestArea-data-option">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment"
  import {getsysUserGroup, getWormStatisticsByGroup} from "../../until/api/SporePest";
  export default {
    name: 'PestAreaData',
    components:{},
    data() {
      return {
        pestAreaList:[],
        defaultPestArea: '',
        defaultPestAreaName: '',
        defaultAreaTime: [ moment().format("YYYY-MM-DD HH:mm:ss"), moment().subtract(-1, "days").format("YYYY-MM-DD HH:mm:ss")],
        areaPickerOption: {
          shortcuts:[{
            text: '最近一天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '最近半个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        beginTime: '',
        endTime: '',
        wornName: [],
        wornNum: [],
        wornData: []
      }
    },

    mounted() {
      this.pestAreaDevice();//获取区域id
      this.beginTime = moment().format("YYYY-MM-DD HH:mm:ss"); //初期化开始时间
      this.endTime = moment().subtract(-1, "days").format("YYYY-MM-DD HH:mm:ss"); //初期化结束时间
    },
    methods: {
      /**
       * 获取区域id
       */
      pestAreaDevice() {
        let that = this;
        let areaDevice = [];
        this.$SporeSoilCommon.getSpDeviceList(function (deviceList) {
          if(deviceList.code != 2000) {
            for(let i = 0; i < deviceList.data.length; i++) {
              if(deviceList.data[i].deviceType.indexOf('worm') > -1) { //筛选出虫情区域id
                if(areaDevice.indexOf(deviceList.data[i].groupId) === -1) { //虫情区域id去重
                  areaDevice.push(deviceList.data[i].groupId);
                }
              }
            }
            that.pestAreaGround(areaDevice);//获取区域名以及区域id
          }
        })
      },

      /**
       * 获取区域名以及区域id
       * @param areaDevice
       */
      pestAreaGround(areaDevice) {
        getsysUserGroup().then(response => {
          for(let i = 0; i < response.data.data.length; i++) {
            for(let j = 0; j < areaDevice.length; j++) {
              if(areaDevice[j] == response.data.data[i].groupId ) {
                let pestJson = {};
                pestJson.groupId = response.data.data[i].groupId; //区域id
                pestJson.groupName = response.data.data[i].groupName; //区域名
                this.pestAreaList.push(pestJson);
                break;
              }
            }
          }
          if(this.pestAreaList.length > 0) {
            this.defaultPestArea = this.pestAreaList[0].groupId; //初期化默认区域id
            this.defaultPestAreaName = this.pestAreaList[0].groupName;//初期化默认区域名称
          }
        }).catch(error => {
          console.log("error", error);
        })
      },

      /**
       * 切换区域
       * @param event
       */
      pestDeviceChange(event) {
        this.defaultPestArea = event; //获取默认的区域id
        for(let i = 0; i < this.pestAreaList.length; i++) {
          if(this.defaultPestArea == this.pestAreaList[i].groupId) {
            this.defaultPestAreaName = this.pestAreaList[i].groupName;//初期化默认区域名称
          }
        }
        //清空数据
        this.wornName = [];
        this.wornNum = [];
        this.wornData = [];

        //清空柱状图
        document.getElementById("worn").removeAttribute("_echarts_instance_");
        let worn = this.$echarts.init(document.getElementById('worn'));
        worn.setOption({});

      },

      /**
       * 获取选中的时间
       * @param val
       */
      areaSelectTime(val) {
        if(val === null) { //清空时间
          this.defaultAreaTime = [moment().format("YYYY-MM-DD HH:mm:ss"), moment().subtract(-1, "days").format("YYYY-MM-DD HH:mm:ss")]; //默认显示的时间
          this.beginTime = moment().format("YYYY-MM-DD HH:mm:ss"); //默认开始时间
          this.endTime = moment().subtract(-1, "days").format("YYYY-MM-DD HH:mm:ss"); //默认结束时间
        } else { //非清空时间
          this.beginTime = moment(new Date(val[0]).getTime()).format("YYYY-MM-DD HH:mm:ss"); //选中的开始时间
          this.endTime = moment(new Date(val[1]).getTime()).format("YYYY-MM-DD HH:mm:ss"); //选中的结束时间
        }
      },

      /**
       * 查询
       */
      areaQueryData() {
        this.areaWormData();//获取区域虫情数据
      },

      /**
       * 获取区域虫情数据
       */
      areaWormData() {
        //清空数据
        this.wornName = [];
        this.wornNum = [];
        this.wornData = [];

        //清空柱状图
        document.getElementById("worn").removeAttribute("_echarts_instance_");
        let worn = this.$echarts.init(document.getElementById('worn'));
        worn.setOption({});

        //获取区域冲死去那个数据
        getWormStatisticsByGroup(this.defaultPestArea, this.beginTime, this.endTime).then(response => {
          if(response.data.message == '操作成功') {
            if(response.data.data.length > 0) {
              for(let i = 0; i < response.data.data[0].wornData.length; i++) {
                this.wornName.push(response.data.data[0].wornData[i].name);
                this.wornNum.push(response.data.data[0].wornData[i].num);
                this.wornData.push(response.data.data[0].wornData[i]);
              }
              this.$nextTick(() => {
                this.setWarnOption(); //加载折线图
              })
            } else { //未查询出数据
              this.$message({
                showClose: true,
                type: 'warning',
                message: '所选时间段内未查询出数据'
              })
            }
          } else { //选择的时间超出15天
            this.$message({
              showClose: true,
              type: 'warning',
              message: response.data.message
            })
          }
        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 加载折线图
       */
      setWarnOption() {
        let worn = this.$echarts.init(document.getElementById('worn'));
        window.addEventListener("resize",function(){
          worn.resize()  // myChart 是实例对象
        });

        worn.setOption({
          color: ['#0FFF06',],
          title: {
            text: this.defaultPestAreaName + ' 虫情统计',
            left: 'center',
            textStyle: {
              color: '#ffffff',//#ffffff
              fontSize: 22,
              lineHeight: 30,
              fontWeight: 'normal'
            }
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            left: '2%',
            right: '5%',
            bottom: '2%',
            top: '8%',
            containLabel: true,
          },
          xAxis: {
            name: '名称',
            type: 'category',
            nameTextStyle:{
              color:'#ffffff',
              fontSize:15
            },
            boundaryGap: true,
            data: this.wornName,
            offset: 3,
            axisLabel: {
              // interval: 0,
              // rotate: -20,
              show: true,
              textStyle: {
                color: '#ffffff',
                fontSize :15,
              },
            },
            axisLine:{
              show :true,
              lineStyle:{
                color:'#ffffff'
              }
            },
            axisTick:{
              show :true,
            }
          },
          yAxis: {
            name: '数值',
            type: 'value',
            nameTextStyle:{
              color:'#ffffff',
              fontSize :15,
            },
            show: true,
            axisLabel: {
              show: true,
              textStyle: {
                color: '#ffffff'
              },
            },
            splitLine:{
              show: false,
              lineStyle: {
                color: ['#153a8a']
              }
            },
            axisLine:{
              show :true,
              lineStyle:{
                color:'rgba(231, 244, 255, 0.2)'
              }
            },
            axisTick:{
              show :false,
            },
          },
          series: [
            {
              type: 'bar',
              data: this.wornNum,
              itemStyle:{
                color:'#67e0e3',
                normal: {
                  label: {
                    show: true,
                    position: 'top',
                    textStyle: {
                      color: '#ffffff',
                      fontSize: 15
                    },
                  },
                  //color:'#67e0e3'
                  //color:function(){return "#"+Math.floor(Math.random()*(256*256*256-1)).toString(16);}
                  color: function (params) {
                    // params.dataIndex指的是每个柱状图的索引下标 分别为0 1 2 3 4 5 6 7 8 9
                    let colorArr = ["#ffa043", "#5471c8", "#934dce", "#33b6ff", "#91cc75", "#73c0de", "#4944fe", "#06e278", "#00ffff", "#1DFF41"]; //colorArr.length 为3，通过取模的方式就可以循环使用颜色了
                    return colorArr[params.dataIndex % colorArr.length];
                  },
                },
              },
              tooltip: { //提示框
                trigger: 'axis',
                axisPointer: { // 坐标轴指示器，坐标轴触发有效
                  type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                },
              },
            },
          ],
        })
      },

      /**
       * 导出
       */
      areaExportData() {
        let that = this;
        if(that.wornData.length === 0) {
          that.$message({
            showClose: true,
            type: "warning",
            message: '未查询到数据',
            duration: 5000
          })
          return;
        }
        const {export_json_to_excel} = require('../../vendor/Export2Excel');
        const tHeader = ["虫种类", "虫数量"];
        const filterVal = ['name', 'num'];
        const list = that.wornData;
        const data = that.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, this.defaultPestAreaName + "_虫情统计");
      },

      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j=>v[j]))
      }
    }
  }
</script>

<style lang="less">
  @import "../less/PestAreaData";
</style>

<style>
  .pestArea-data-content::-webkit-scrollbar {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/PestAreaData.vue